<template>
  <div class="step-wrapper">
    <Menu current="2" :finish="finish"></Menu>
    <div class="step-inner page_detail" :class="'part' + curPart">
      <!--  -->
      <div class="banner-wrapper">
        <swiper class="banner-list" :options="swiperOption" v-if="picture.length">
          <swiper-slide class="banner-item" v-for="(item, index) in picture" :key="index">
            <div class="banner-item-img" :style="{ backgroundImage: 'url(' + hostUrl + item + ')' }"></div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <img src="~@static/funding_cpunk/creation/pic_border.png" class="cover" alt="" />
      </div>
      <!--  -->
      <div class="project-basic">
        <h1 class="project-title">{{ projectCreateData.title }}</h1>
        <h2 class="project-sub-title">{{ projectCreateData.summary }}</h2>
        <!--  -->
        <div class="project-city"><img src="~@static/funding/icon-pin.png" class="icon" />{{ projectCreateData.city }}</div>
        <div class="project-author project-time" v-if="projectCreateData.plan_status == 1">
          <img class="icon" src="~@static/fundingnew_/icon-time.png" />
          <span class="text">{{ projectCreateData.event_time }}</span>
        </div>
        <ul class="project-tags-list">
          <li class="tag-item" v-for="item of projectCreateData.tags" :key="item.id">#{{ item }}</li>
        </ul>
      </div>

      <div class="project-desc show">
        <div class="t" v-html="description"></div>
      </div>

      <div class="video-preview">
        <div class="video-cover" v-if="videoId">
          <iframe frameborder="0" width="100%" height="100%" :src="previewVideoUrl" allowfullscreen></iframe>
        </div>
        <div v-else class="video-cover">
          <img src="~@static/fundingnew/creation/step2/video-cover.jpg" />
        </div>
      </div>
      <div class="project-input-cell links">
        <div class="item">
          <div class="icon">
            <img src="~@static/funding_cpunk/creation/icon-link.png" alt="" />
          </div>
          <div class="bar gradient-bg">
            <input placeholder="粘贴参考视频链接" v-model="video.url" />
          </div>
        </div>
      </div>
      <!-- <div class="project-input-cell links">
        <div class="item">
          <div class="icon">
            <img src="~@static/funding_cpunk/creation/icon-link.png" alt="" />
          </div>
          <div class="bar gradient-bg">
            <input placeholder="粘贴其他链接" v-model="links[0].url" />
          </div>
        </div>
      </div>
      <div class="project-input-cell links">
        <div class="item">
          <div class="icon"></div>
          <div class="bar gradient-bg">
            <input placeholder="其他链接描述" v-model="links[0].desc" />
          </div>
        </div>
      </div> -->
      <div class="project-input-cell people">
        <div class="item">
          <div class="icon">
            <img src="~@static/funding_cpunk/creation/icon-people.png" alt="" />
          </div>
          <div class="bar gradient-bg">
            <input type="tel" placeholder="输入夜计划规模" v-model.number="num" maxlength="4" />
          </div>
        </div>
      </div>
      <div style="height: 150px"></div>

      <div class="mask" style="display: block"></div>

      <div class="step2-1-tip" v-if="curPart == 1">
        <img class="step2-0" src="~@static/funding_cpunk/creation/step2_1.png" alt="" key="1" />
        <div class="banner-wrapper1" v-if="pictures.length === 0">
          <div class="cover-bg"></div>
          <img src="~@static/funding_cpunk/creation/pic_border.png" class="cover" alt="" />
          <div class="form-input">
            <vue-core-image-upload
              style="width: 100%; height: 100%; opacity: 0"
              :class="['button', 'file-btn', 'btn-lg', 'btn-block']"
              :crop="false"
              @imageuploaded="imageuploaded"
              @imageuploading="imageuploading"
              inputOfFile="file"
              :max-file-size="5242880"
              :compress="30"
              :max-width="200"
              input-accept="image/*"
              :url="uploadUrl"
            >
            </vue-core-image-upload>
          </div>
        </div>
        <div class="upload-imgs-list" v-if="pictures.length > 0">
          <div v-for="(item, index) in pictures" :key="index" class="upload-img-item">
            <img class="upload-img" :src="hostUrl + item" />
            <img class="close-btn" src="~@images/regular/creation/step2/icon-close.png" :data-src="item" @click="delPhoto" />
          </div>
          <div class="upload-img-item upload-piece" v-show="pictures.length < 4">
            <vue-core-image-upload
              style="width: 100%; height: 100%; opacity: 0"
              :class="['button', 'file-btn', 'btn-lg', 'btn-block']"
              :crop="false"
              @imageuploaded="imageuploaded"
              @imageuploading="imageuploading"
              inputOfFile="file"
              :max-file-size="5242880"
              :compress="30"
              :max-width="200"
              input-accept="image/*"
              :url="uploadUrl"
            >
            </vue-core-image-upload>
          </div>
        </div>
        <div class="btn_step btn_next" @click="bindToNextPart" :data-part="curPart" :class="part1.active ? 'active' : ''">下一步</div>
      </div>

      <div class="step2-3-tip" v-if="curPart == 3">
        <img class="step2-3" src="~@static/funding_cpunk/creation/step2_3.png" alt="" key="1" />
        <div class="project-desc">
          <div class="desc-placeholer" v-if="description == '' && !focus" @click.stop.prevent="handleClickTextarea"></div>
          <!-- 输入活动详情介绍例如：举办的活动和主题如何关联、活动流程细节 （包含场地类型、音乐类型、演出情况等） -->
          <textarea class="t" ref="focusTextarea" @blur.prevent="handleBlurTextarea" placeholder="" v-model.trim="description" @input="bindDescriptionChange" />
        </div>
        <div class="btn_step btn_prev" @click="bindToPrevPart" :data-part="curPart" :class="part1.active ? 'active' : ''">上一步</div>
        <div class="btn_step btn_next" @click="bindToNextPart" :data-part="curPart" :class="part3.active ? 'active' : ''">下一步</div>
      </div>

      <div class="step2-4-tip" v-if="curPart == 4">
        <div class="video-preview">
          <div class="video-cover" v-if="videoId">
            <iframe frameborder="0" width="100%" height="100%" :src="previewVideoUrl" allowfullscreen></iframe>
          </div>
          <div v-else class="video-cover" @click="getVideoVid">
            <img src="~@static/fundingnew/creation/step2/video-cover.jpg" />
          </div>
        </div>

        <div class="project-input-cell-box">
          <div class="project-input-cell links">
            <div class="item">
              <div class="bar gradient-bg">
                <input placeholder="粘贴参考视频链接" v-model="video.url" @input="bindVideoUrlChange" />
              </div>
            </div>
          </div>
          <!-- <div class="project-input-cell links">
            <div class="item">
              <div class="icon">
                <img src="~@static/funding_cpunk/creation/icon-link.png" alt="" />
              </div>
              <div class="bar gradient-bg">
                <input placeholder="粘贴其他链接" v-model="links[0].url" />
              </div>
            </div>
          </div>
          <div class="project-input-cell links">
            <div class="item">
              <div class="icon"></div>
              <div class="bar gradient-bg">
                <input placeholder="其他链接描述" v-model="links[0].desc" />
              </div>
            </div>
          </div> -->
        </div>

        <img class="step2-4" src="~@static/funding_cpunk/creation/step2_4.png" alt="" />
        <div class="btn_step btn_prev" @click="bindToPrevPart" :data-part="curPart" :class="part3.active ? 'active' : ''">上一步</div>
        <div class="btn_step btn_next" @click="bindToNextPart" :data-part="curPart" :class="part4.active ? 'active' : ''">下一步</div>
      </div>

      <div class="step2-5-tip" v-if="curPart == 5">
        <div class="project-input-cell-box">
          <div class="project-input-cell people">
            <div class="item">
              <div class="bar gradient-bg">
                <input type="tel" class="form-control" placeholder="输入夜计划规模" v-model.number="num" maxlength="4" @input="bindCapacityChange" />
              </div>
            </div>
          </div>
        </div>
        <img class="step2-5" src="~@static/funding_cpunk/creation/step2_5.png" alt="" />
        <div class="btn_step btn_prev" @click="bindToPrevPart" :data-part="curPart" :class="part4.active ? 'active' : ''">上一步</div>
        <div class="btn_step btn_next" @click="bindToNextPart" :data-part="curPart" :class="part5.active ? 'active' : ''">完成</div>
      </div>

      <!-- 页面滚动锚点 -->
      <div class="part3-ancor"></div>
      <div class="part4-ancor"></div>
      <div class="part5-ancor"></div>
    </div>
  </div>
</template>

<script>
import Menu from '../components/Menu'
import VueCoreImageUpload from 'vue-core-image-upload'
import { mapState, mapMutations } from 'vuex'
import { behavior } from '@/utils/behavior'
export default {
  name: '',
  components: {
    Menu,
    VueCoreImageUpload,
  },
  data() {
    return {
      hostUrl: this.$apiConfig.host,
      uploadUrl: this.$apiConfig.uploadUrl,
      projectCreateData: {},
      swiperDuration: 800,
      swiperCurrent: 0,
      curPart: 1,
      part1: {
        active: false,
      },
      part3: {
        active: false,
      },
      part4: {
        active: true,
      },
      part5: {
        active: true,
      },
      picture: [], //含封面图
      pictures: [],
      description: '',
      focus: false,
      links: [
        {
          url: '',
          desc: '',
        },
      ],
      previewVideoUrl: '',
      videoId: '',
      video: {
        url: '',
        desc: '',
      },
      upload_img_arr: [],
      recording: false,
      description_link: '',
      num: '',
      finish: 0,
      voicePlaying: false,
      from: '',
      theme: {
        value: '',
        name: '',
      },
      loading: false,
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
        },
        //循环
        loop: true,
        initialSlide: 0,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        //滑动方向
        direction: 'horizontal',
        preventLinksPropagation: false,
      },
    }
  },
  computed: {
    ...mapState(['fundingNewProjectCreate', 'authorization', 'nickname', 'mobile']),
  },
  created() {
    let { from } = this.$route.query
    if (from == 'preview') {
      this.from = 'preview'
    }
  },
  mounted() {
    let { cover, pictures, description, description_link, video, links, num } = this.fundingNewProjectCreate
    this.fundingNewProjectCreate.userName = this.nickname

    if (typeof pictures != 'undefined') {
      this.pictures = pictures
      this.description = description
      this.description_link = description_link
      this.video = video
      this.links = links.length == 0 ? this.links : links
      this.num = num
      this.part1.active = true
      this.part3.active = true
      this.part4.active = true
      this.part5.active = true
    }

    this.picture.push(cover)
    this.projectCreateData = JSON.parse(JSON.stringify(this.fundingNewProjectCreate))
    this.picture = this.picture.concat(this.pictures)
    this.upload_img_arr = this.pictures
    this.requestThemesData()
    this.finishedStep()
  },
  methods: {
    ...mapMutations(['setFundingNewProjectCreate']),
    handleClickTextarea() {
      this.$refs.focusTextarea.focus()
      this.focus = true
    },
    handleBlurTextarea() {
      this.focus = false
    },
    uploadPhoto() {},
    requestThemesData() {
      this.$request.get(this.$apiConfig.topicsUrl).then(res => {
        let resData = res.data
        let result = resData.data
        if (resData.code == 0 && result) {
          this.theme = {
            name: result.items[0].title,
            value: result.items[0].id,
          }
        }
      })
    },
    imageuploaded(res) {
      if (res.code == 0) {
        this.upload_img_arr.push(res.data.base)
        this.pictures = this.upload_img_arr
        this.part1.active = true
      } else {
        alert('上传失败')
      }
      this.loading = false
      _jcq.push(['_track', 'yjhbcimage_upload'])
      behavior({ behavior_code: 'prc_bhv_abs_bcyjh_bc24' })
    },
    imageuploading() {
      this.loading = true
    },
    delPhoto(e) {
      const src = e.currentTarget.dataset.src
      const index = this.upload_img_arr.indexOf(src)

      let isConfrim = confirm('确定要删除此图片？')
      if (isConfrim) {
        this.upload_img_arr.splice(index, 1)
        if (this.upload_img_arr.length == 0) {
          this.part1.active = false
        }
        this.pictures = this.upload_img_arr
      }
    },
    bindDescriptionChange() {
      if (this.description != '') {
        this.part3.active = true
      } else if (this.description_link == '') {
        this.part3.active = false
      }
    },
    bindCapacityChange() {
      if (this.num != '') {
        this.part5.active = true
      } else {
        this.part5.active = false
      }
    },
    getVideoVid() {
      if (this.video.url == '') {
        alert('请先输入视频链接')
        return
      }
      let _url = this.video.url

      if (_url) {
        let vid = ''
        if (_url.includes('b23.tv')) {
          this.$request.post(this.$apiConfig.videoUrl, { url: _url }).then(res => {
            let resData = res.data
            if (resData.code == 0) {
              let u = resData.data.redirect_url
              let i0 = u.indexOf('?')
              if (i0 != -1) {
                u = u.slice(0, i0)
              }
              let u1 = u.split('/')
              vid = u1[u1.length - 1]
              this.previewVideoUrl = `https://player.bilibili.com/player.html?bvid=${vid}&page=1`
              this.videoId = vid
              _jcq.push(['_track', 'yjhbcvideo_click'])
              behavior({ behavior_code: 'prc_bhv_abs_bcyjh_bc27' })
              return
            }
          })
        }

        if (_url.includes('bilibili')) {
          if (_url.match(/\/$/) != null) {
            _url = _url.slice(0, -1)
          }
          _url = _url.split('/')
          vid = _url[_url.length - 1]
          this.previewVideoUrl = `https://player.bilibili.com/player.html?bvid=${vid}&page=1`
        } else {
          _url = _url.split('/')
          vid = _url[_url.length - 1].split('.')[0]
          this.previewVideoUrl = `https://v.qq.com/txp/iframe/player.html?vid=${vid}&tiny=0&auto=0`
        }
        this.videoId = vid
        _jcq.push(['_track', 'yjhbcvideo_click'])
        behavior({ behavior_code: 'prc_bhv_abs_bcyjh_bc27' })
      }
    },
    bindVideoUrlChange(e) {
      this.videoId = ''
    },
    bindLinkUrlChange() {
      console.log(this.links)
    },
    bindToNextPart(e) {
      let partId = e.currentTarget.dataset.part
      if (partId == 1) {
        if (this.pictures.length == 0) {
          alert('请上传1到4张活动参考图')
          return
        }
        this.curPart = 3
        let { cover } = this.projectCreateData
        this.picture = cover ? [cover].concat(this.pictures) : this.pictures

        window.scroll({
          top: document.querySelector('.part3-ancor').offsetTop,
          behavior: 'smooth',
        })
        _jcq.push(['_track', 'yjhbcinfo_next'])
        behavior({ behavior_code: 'prc_bhv_abs_bcyjh_bc25' })
      }
      if (partId == 3) {
        if (this.description == '' && this.description_link == '') {
          alert('请输入夜计划详情介绍')
          return
        }

        this.curPart = 4

        window.scroll({
          top: document.querySelector('.part4-ancor').offsetTop,
          behavior: 'smooth',
        })
      }
      if (partId == 4) {
        if (this.links[0].url != '' && this.links[0].desc == '') {
          alert('请输入其他链接描述')
          return
        }
        if (this.links[0].url == '' && this.links[0].desc != '') {
          alert('请输入其他链接')
          return
        }
        this.curPart = 5

        window.scroll({
          top: document.querySelector('.part5-ancor').offsetTop,
          behavior: 'smooth',
        })
      }
      if (partId == 5) {
        if (isNaN(this.num) || this.num < 1) {
          alert('请输入夜计划规模')
          return
        }

        //保存数据
        let { cover } = this.projectCreateData

        let step2Data = {
          pictures: this.pictures,
          picture: cover ? [cover].concat(this.pictures) : this.pictures,
          description: this.description,
          description_link: this.description_link,
          video: this.video,
          theme: this.theme,
          links: this.links[0].url.length == 0 && this.links[0].desc.length == 0 ? [] : this.links,
          num: this.num,
          step2Finish: true,
        }

        //存入storage
        this.setFundingNewProjectCreate({
          ...this.fundingNewProjectCreate,
          ...step2Data,
        })

        if (this.path_from == 'preview') {
          this.$router.replace({ path: '/fundingnew/creation/preview', query: this.$route.query })
        } else {
          this.$router.replace({ path: '/fundingnew/creation/step3', query: this.$route.query })
        }
      }
    },
    bindToPrevPart(e) {
      let partId = e.currentTarget.dataset.part
      if (partId == 3) {
        this.curPart = 1
        window.scroll({
          top: 0,
          behavior: 'smooth',
        })
      }
      if (partId == 4) {
        this.curPart = 3
        window.scroll({
          top: document.querySelector('.part3-ancor').offsetTop,
          behavior: 'smooth',
        })
      }
      if (partId == 5) {
        this.curPart = 4
        window.scroll({
          top: document.querySelector('.part4-ancor').offsetTop,
          behavior: 'smooth',
        })
      }
    },
    finishedStep() {
      let { step1Finish, step2Finish, step3Finish } = this.fundingNewProjectCreate

      if (typeof step3Finish != 'undefined') {
        this.finish = 3
        return
      }
      if (typeof step2Finish != 'undefined') {
        this.finish = 2
        return
      }
      if (typeof step1Finish != 'undefined') {
        this.finish = 1
        return
      }
    },
    playVoice() {},
    startRecording() {},
    stopRecording() {},
  },
}
</script>

<style lang="scss" scoped>
@import '@styles/cpunk.scss';
.part3-ancor {
  position: absolute;
  top: pxtow(600);
}
.part4-ancor {
  position: absolute;
  top: pxtow(1000);
}
.part5-ancor {
  position: absolute;
  top: pxtow(1500);
}
.step2-1-tip {
  position: absolute;
  left: 0;
  top: pxtow(150);
  width: 100%;
  z-index: 11;
  .banner-wrapper1 {
    position: relative;
    width: pxtow(664);
    height: pxtow(351);
    padding: pxtow(7) pxtow(7);
    margin: 0 auto;
    .cover-bg {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: url('~@static/funding_cpunk/creation/upload_img.png') no-repeat 50% 50%;
      background-color: #000;
      background-size: pxtow(70) pxtow(70);
    }
    .cover {
      position: absolute;
      left: pxtow(0);
      top: pxtow(0);
      width: pxtow(664);
      height: pxtow(351);
      pointer-events: none;
    }
  }
  .step2-0 {
    position: absolute;
    top: pxtow(390);
    left: pxtow(260);
    width: pxtow(253);
    height: pxtow(233);
    z-index: 2;
  }
  .btn_next {
    top: 102vw;
    left: 39vw;
  }
  .form-input {
    width: pxtow(664);
    height: pxtow(351);
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
  }
  .upload-imgs-list {
    width: pxtow(664);
    height: pxtow(351);
    position: absolute;
    left: pxtow(56);
    top: pxtow(7);
    z-index: 2;
  }
  .upload-imgs-list-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: auto;
  }
  .upload-img-item {
    float: left;
    position: relative;
    width: pxtow(154);
    height: pxtow(154);
    background: url('~@images/regular/creation/step2/part1-img-border.png') no-repeat 0 0;
    background-size: 100% auto;
    &:not(:nth-child(4n + 4)) {
      margin-right: pxtow(6);
    }
    margin-bottom: pxtow(10);
    overflow: hidden;
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .upload-img-item .upload-img {
    position: absolute;
    top: pxtow(2);
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    height: 100%;
    border-radius: pxtow(10);
    object-fit: cover;
  }

  .upload-img-item .close-btn {
    position: absolute;
    top: 0;
    right: 0;
    width: pxtow(50);
    height: pxtow(50);
    text-align: center;
    box-sizing: content-box;
  }
  .upload-piece {
    background: url('~@images/regular/creation/step2/part1-icon.png') no-repeat 50% 50%;
    background-size: 100% auto;
  }
}
.step2-3-tip {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 11;
  .step2-3 {
    position: absolute;
    left: pxtow(200);
    top: pxtow(617);
    width: pxtow(371);
    height: pxtow(160);
  }
  .btn_prev {
    top: pxtow(1145);
    left: pxtow(158);
  }
  .btn_next {
    top: pxtow(1145);
    left: pxtow(390);
  }
  .project-desc {
    position: absolute;
    top: pxtow(796);
    left: pxtow(26);
    z-index: 2;
    width: pxtow(698);
    height: pxtow(297);
    background: url('~@static/funding_cpunk/creation/banner.png') no-repeat 0 0;
    background-size: 100% auto;
    color: #fff;
    .desc-placeholer {
      position: absolute;
      width: pxtow(526);
      height: pxtow(112);
      left: pxtow(90);
      top: pxtow(92);
      background: url('~@static/funding_cpunk/creation/placehold_t1.png') no-repeat 50% 50%;
      background-size: pxtow(526) auto;
      z-index: 2;
    }
    .t {
      position: absolute;
      left: pxtow(70);
      top: pxtow(70);
      width: pxtow(546);
      height: pxtow(150);
      overflow: hidden;
      background-color: transparent;
      border: none;
    }
  }
}
.step2-4-tip {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 11;
  ::placeholder {
    color: #000;
  }
  .video-preview {
    margin-top: 0;
    position: absolute;
    top: pxtow(1232);
    left: 0;
    width: 100%;
    padding: 0 pxtow(5);
    height: pxtow(422);
  }
  .step2-4 {
    position: absolute;
    top: pxtow(1000);
    left: pxtow(118);
    width: pxtow(509);
  }
  .btn_prev {
    top: pxtow(1106);
    left: pxtow(158);
  }
  .btn_next {
    top: pxtow(1106);
    left: pxtow(390);
  }
  .project-input-cell-box {
    position: absolute;
    left: 0;
    top: pxtow(1662);
    width: 100%;
    .project-input-cell .item input {
      width: 100%;
      text-align: center;
    }
  }
}

.step2-5-tip {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 11;
  ::placeholder {
    color: #000;
  }
  .step2-5 {
    position: absolute;
    top: pxtow(1660);
    left: pxtow(223);
    width: pxtow(310);
    height: pxtow(223);
  }
  .btn_prev {
    top: pxtow(1710);
    left: pxtow(158);
  }
  .btn_next {
    top: pxtow(1710);
    left: pxtow(390);
  }
  .project-input-cell-box {
    position: absolute;
    left: 0;
    top: pxtow(1944);
    width: 100%;
    .project-input-cell .item input {
      width: 100%;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/fundingnew/creation/Step2.vue